import http from "../http-common";
import { messageFnc } from "../components/message";
import { errorCode } from "../untils/constanst";

export const getBranchsApi = async () => {
	return await http
		.get("/getbranches")
		.then((res) => {
			if (res.data.code === 2000) {
				return res.data;
			} else {
			}
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

export const checkRoom = async (formRoom) => {
	return await http
		.post("/checkroom", formRoom)
		.then((res) => {
			if (res.data.code === 2000) {
				return res.data;
			} else {
				if (res?.data?.code && res?.data?.code !== 2101) {
					messageFnc("Message", "error", errorCode[res?.data?.code]);
				}
				return res.data;
			}
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

export const BOOKING_PROCESSING_CODE = 1014;
export const BOOK_ROOM_TIMEOUT_MS = 25000;
const BOOK_ROOM_RETRY_WINDOW_MS = 45000;
const BOOK_ROOM_RETRY_DELAY_MS = 2000;
const BOOK_ROOM_MIN_ATTEMPT_MS = 3000;
// Mã do trang tự xử lý (captcha, hết phòng); mã khác hiện thông báo tại đây.
const BOOK_ROOM_HANDLED_CODES = [2000, 1009, 1010, 2101, 1007];
// Request có thể đã tới server: chỉ an toàn gửi lại khi có request_id.
const isUnconfirmedFailure = (error) =>
	!error?.response || [502, 503, 504].includes(error.response.status);
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const createBookingRequestId = () => {
	if (typeof crypto !== "undefined" && crypto.randomUUID) {
		return crypto.randomUUID();
	}
	return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

// Gửi lại cùng request_id khi mất mạng/hết giờ hoặc server báo đang xử lý:
// server trả lại đúng đơn đã tạo, không tạo đơn thứ hai.
export const bookRoom = async (formRoom, options = {}) => {
	const {
		retryWindowMs = BOOK_ROOM_RETRY_WINDOW_MS,
		retryDelayMs = BOOK_ROOM_RETRY_DELAY_MS,
	} = options;
	const canRetry = Boolean(formRoom?.request_id);
	const deadline = Date.now() + retryWindowMs;
	let lastData;
	for (;;) {
		const timeout = Math.min(BOOK_ROOM_TIMEOUT_MS, Math.max(deadline - Date.now(), BOOK_ROOM_MIN_ATTEMPT_MS));
		try {
			const res = await http.post("/book_room", formRoom, { timeout });
			lastData = res?.data;
			if (!canRetry || lastData?.code !== BOOKING_PROCESSING_CODE) {
				break;
			}
		} catch (error) {
			if (!canRetry || !isUnconfirmedFailure(error)) {
				messageFnc(
					"Message",
					"error",
					errorCode[error?.response?.data?.code] ||
						"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
				return undefined;
			}
			lastData = undefined;
		}
		if (deadline - Date.now() < retryDelayMs + BOOK_ROOM_MIN_ATTEMPT_MS) {
			break;
		}
		await wait(retryDelayMs);
	}
	if (!lastData) {
		messageFnc(
			"Message",
			"error",
			"Chưa xác nhận được kết quả đặt phòng do kết nối không ổn định. Vui lòng bấm Đặt phòng lại để kiểm tra, hệ thống sẽ không tạo thêm đơn trùng.",
		);
	} else if (!BOOK_ROOM_HANDLED_CODES.includes(lastData?.code)) {
		messageFnc(
			"Message",
			"error",
			lastData?.code === 1000
				? "Hệ thống đang bận, vui lòng thử lại sau ít giây."
				: errorCode[lastData?.code] || "Đặt phòng chưa thành công, vui lòng thử lại.",
		);
	}
	return lastData;
};

export const checkBookedRoom = async (formRoom) => {
	return await http
		.post("/check_booked_room", formRoom)
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};



export const checkDiscount = async (formDiscount) => {
	return await http
		.post("/check_discount", formDiscount)
		.then((res) => {
			if (res.data.code === 2000) {
				return res.data;
			} else {
				if (res?.data?.code && res?.data?.code !== 2101) {
					messageFnc("Message", "error", errorCode[res?.data?.code]);
				}
				return res.data;
			}
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};


export const getCaptcha = async (captcha_id) => {
	return await http
		.get(`/captcha?captcha_id=${captcha_id}`, { responseType: "blob" })
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

export const removeRoom = async (roomId) => {
	return await http
		.delete(`/removeroom/${roomId}`)
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

export const cancelRoom = async (book_id) => {
	return await http
		.post(`/cancel`, { book_id })
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

export const getBlogApi = async (blogId) => {
	return await http
		.get(`/get_post_detail`, {
			params: {
				post_id: blogId,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

export const getBlogsApi = async () => {
	return await http
		.get(`/get_posts`)
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};


export const getBlogsHome = async () => {
	return await http
		.get(`/posts_for_home`)
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};

// The QR view owns loading/retry errors; do not open a second global modal.
export const getQrCode = async (book_id, signal) =>
  (await http.get(`/booking_qr?book_id=${encodeURIComponent(book_id)}`, {
    responseType: "blob", signal,
  })).data;

export const suggestAlternatives = async (formRoom) => {
	return await http
		.post("/suggest_alternatives", formRoom)
		.then((res) => {
			if (res.data.code === 2000) {
				return res.data;
			} else {
				if (res?.data?.code && res?.data?.code !== 2101) {
					messageFnc("Message", "error", errorCode[res?.data?.code]);
				}
				return res.data;
			}
		})
		.catch((error) => {
			if (error?.response?.data) {
				messageFnc("Message", "error", errorCode[error?.response?.data?.code]);
			} else {
				messageFnc(
					"Message",
					"error",
					"Hệ thống đang gặp lỗi, xin vui lòng thử lại sau ít phút!",
				);
			}
		});
};
